import { MsalConfig } from '../msalConfig';

export const isAuthMocked = process.env.REACT_APP_USE_AUTH_MOCK === 'true';

export interface Config {
	baseUrl?: string;
	msal: MsalConfig;
}

export const defaultConfig: Config = {
	baseUrl: process.env.REACT_APP_BASE_URL,
	msal: {
		clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '',
		authority: process.env.REACT_APP_MSAL_AUTHORITY || '',
		knownAuthorities: process.env.REACT_APP_MSAL_KNOWN_AUTHORITIES?.split(',').filter(Boolean) || [],
		redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI || window.location.origin,
		scopes: (process.env.REACT_APP_MSAL_SCOPES || '').split(',').filter(Boolean),
		allowedTenantIds: (process.env.REACT_APP_MSAL_ALLOWED_TENANT_IDS || '').split(',').filter(Boolean),
	}
};

export const dynamicConfigUrl =
	'/config.json?' + new Date().getTime().toString();
